var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    clipPath: "url(#clip0_11431_14777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.116 3.52344L1.21212 13.428C1.16229 13.478 1.12631 13.5411 1.10918 13.6089L0.0114342 18.015C-0.0214026 18.1477 0.0175732 18.2887 0.11437 18.3855C0.187611 18.4587 0.287406 18.4993 0.389485 18.4993C0.420752 18.4993 0.452732 18.4954 0.483855 18.4876L4.88998 17.3897C4.95865 17.3726 5.02104 17.3367 5.07087 17.2869L14.9756 7.38304L11.116 3.52344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4287 2.17239L16.3262 1.06993C15.5894 0.333103 14.3052 0.333817 13.5692 1.06993L12.2188 2.42038L16.0782 6.27984L17.4287 4.92939C17.7967 4.56148 17.9994 4.07178 17.9994 3.55096C17.9994 3.03014 17.7967 2.54045 17.4287 2.17239Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11431_14777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.afdd27364b623427d486d894fd8410bc.svg";
export { ForwardRef as ReactComponent };